import settings from '../../server/settings';

export const getVersionApp = () => async (dispatch) => settings.getVersionApp();

export const updateApkClientName = (apkClientName) => async (dispatch) => settings.updateApkClientName(apkClientName);

export const getApkDownloadQr = () => async (dispatch) => settings.getApkDownloadQr();
